import { Button } from '@fluentui/react-components';
import {
  Send24Regular,
  Delete24Regular,
  ArrowSync24Regular,
} from '@fluentui/react-icons';
import { useDraftGeneration } from '../../hooks/useDraftGeneration';
import { useDraftStore } from '../../stores/draftStore';

export function DraftActions() {
  const { insertDraft, discardDraft, generateDraft, isGenerating } = useDraftGeneration();
  const { draft } = useDraftStore();

  if (!draft) return null;

  return (
    <div
      style={{
        display: 'flex',
        gap: 'var(--spacing-sm)',
        paddingTop: 'var(--spacing-md)',
        borderTop: '1px solid var(--color-gray-200)',
      }}
    >
      <Button
        appearance="primary"
        icon={<Send24Regular />}
        onClick={insertDraft}
        disabled={isGenerating}
      >
        Insert into Reply
      </Button>

      <Button
        appearance="secondary"
        icon={<ArrowSync24Regular />}
        onClick={() => generateDraft()}
        disabled={isGenerating}
      >
        Regenerate
      </Button>

      <Button
        appearance="subtle"
        icon={<Delete24Regular />}
        onClick={discardDraft}
        disabled={isGenerating}
      >
        Discard
      </Button>
    </div>
  );
}
